<template>
    <div v-if="estate.is_discounted" class="estate-card-discount-container">
        <masked-image 
            src="/img/icons/arrow-down.svg"
            class="estate-card-discount-icon"
            alt="Prezzo ribassato"            
            ></masked-image>
               
        <span class="estate-card-discount">
            {{ estate.previous_price }}
        </span>

        <span class="estate-card-percent-discount">
            (-{{ estate.discount_percentage }})
        </span>
    </div>
</template>

<script>
export default {
    props: {
        estate: {
            type: Object,
            required: true,
        },
    },
}
</script>